import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { configure } from 'mobx';
import { LoadSentry } from './middlewares/sentry';
import 'url-search-params-polyfill';
import { LoadAppConfigFromEnv } from './config';
import { DomainFactory } from './domain/factory';
import { RouteController } from './route/controller';
import './util';
import { PageProvider, MainContentProvider } from './view/pages/provider';
import { AlertContainerVM } from './view/organisms/alert_container';
import { Root } from './view/root';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
export const AppContainerComponent = ({ alertContainerVM, pageProvider, domainFactory, routeController, }) => {
    const navigate = useNavigate();
    const location = useLocation();
    domainFactory.initializeNavigate(navigate);
    domainFactory.AccountService();
    routeController.initialize(domainFactory, location);
    return React.createElement(Root, { pageProvider: pageProvider, alertContainerVM: alertContainerVM, routeController: routeController });
};
export class AppContainer {
    constructor() {
        Object.defineProperty(this, "alertContainerVM", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "routeController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "domainFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainContentFactory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pageProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const config = LoadAppConfigFromEnv();
        const alertContainerVM = new AlertContainerVM();
        const domainFactory = new DomainFactory(config, alertContainerVM);
        const routeController = new RouteController(domainFactory, alertContainerVM, config);
        const mainContentFactory = new MainContentProvider(domainFactory, alertContainerVM, routeController, config);
        const pageProvider = new PageProvider(mainContentFactory, domainFactory, routeController, alertContainerVM, config);
        this.config = config;
        this.routeController = routeController;
        this.alertContainerVM = alertContainerVM;
        this.domainFactory = domainFactory;
        this.mainContentFactory = mainContentFactory;
        this.pageProvider = pageProvider;
    }
    initialize() {
        LoadSentry(this.config);
        const root = ReactDOM.createRoot(document.getElementById('main'));
        root.render(React.createElement(BrowserRouter, null,
            React.createElement(AppContainerComponent, { alertContainerVM: this.alertContainerVM, pageProvider: this.pageProvider, domainFactory: this.domainFactory, routeController: this.routeController })));
    }
}
configure({ enforceActions: 'never' });
new AppContainer().initialize();
if (module.hot) {
    module.hot.accept((err) => {
        if (err) {
            console.error(err);
        }
    });
}
